import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../images/logo.jpg";
import useAuth from "../../useAuth";
import Cookies from "js-cookie";

const Sidebar = ({ loginName }) => {
  const location = useLocation();
  const { logout } = useAuth();
  const [openTDropdown, setOpenTDropdown] = useState(false);
  const [openMDropdown, setOpenMDropdown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [userRole, setUserRole] = useState("Admin");

  const handleClose = () => {
    setShowModal(false);
  };

  const handleOpen = () => {
    setShowModal(true);
  };

  useEffect(() => {
    // Get the user role from the cookie
    const role = Cookies.get("userRole");
    setUserRole(role);

    // Optionally, you can handle cases where the role is not found
    if (!role) {
      console.warn("User role not found in cookies");
    }
  }, []);

  const toggleTDropdown = () => {
    setOpenTDropdown(!openTDropdown);
  };

  const toggleMDropdown = () => {
    setOpenMDropdown(!openMDropdown);
  };

  return (
    <div className="fixed md:relative top-0 left-0 h-full  md:w-1/6 w-64  max-h-screen overflow-y-auto">
      <div className="p-4">
        <div className="flex items-center gap-1 justify-center">
          <img
            src={logo}
            alt="Logo"
            style={{ width: "20px", height: "20px" }}
          />
          <h1 className="text-xl font-bold font-lato cursor-pointer">
            {" "}
            <Link to="/">Fertiscience</Link>
          </h1>
        </div>
        <div className="bg-liquidblue h-0.5"></div>
      </div>

      <nav className="mt-2 ">
        <ul>
          <li
            className={`p-2 flex font-bold items-center ${
              location.pathname === "/" ? "bg-liquidblue text-white" : ""
            } gap-2 rounded-lg mx-2 my-2`}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0V6H18V0M10 18H18V8H10M0 18H8V12H0M0 10H8V0H0V10Z"
                fill={location.pathname === "/" ? "white" : "#056886"}
              />
            </svg>
            <Link
              to="/"
              className="font-lato transform transition-transform duration-300 hover:scale-105"
            >
              Dashboard
            </Link>
          </li>

          <li
            className={`p-2 font-bold flex items-center ${
              location.pathname === "/territories" ||
              location.pathname === "/territories/show"
                ? "bg-liquidblue text-white"
                : ""
            } gap-2 rounded-lg mx-2 my-2`}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.18 16.6L11.17 13.12C12.15 12.4 12.83 11.28 12.97 10H17C16.83 12.76 15.35 15.16 13.18 16.6ZM10 4.03V0C14.3 0.26 17.74 3.7 18 8H13.97C13.74 5.91 12.09 4.26 10 4.03ZM4 9.5C4 10.14 4.13 10.75 4.38 11.3L0.9 13.31C0.32 12.16 0 10.87 0 9.5C0 4.97 3.54 1.27 8 1V5.03C5.75 5.28 4 7.18 4 9.5ZM8.5 18C5.53 18 2.92 16.5 1.4 14.18L4.88 12.17C5.7 13.28 7 14 8.5 14C9.14 14 9.75 13.87 10.3 13.62L12.31 17.1C11.16 17.68 9.87 18 8.5 18Z"
                fill={
                  location.pathname === "/territories" ||
                  location.pathname === "/territories/show"
                    ? "white"
                    : "#056886"
                }
              />
            </svg>
            <Link
              to="/territories"
              className="font-lato transform transition-transform duration-300 hover:scale-105"
            >
              Territories
            </Link>
            <button onClick={toggleTDropdown} className="ml-5">
              {openTDropdown ? "▲" : "▼"}
            </button>
          </li>
          {openTDropdown && (
            <ul className="mx-10 text-xs">
              <li className="py-1 text-sm text-darkteal font-lato font-bold  transform transition-transform duration-300 hover:scale-105">
                <Link to="/logbooks">Daily Activity Report</Link>
              </li>
              <li className="py-1 text-sm text-darkteal font-lato font-bold transform transition-transform duration-300 hover:scale-105">
                <Link to="/Farmers">Registered Farmer</Link>
              </li>
              <li className="py-1 text-sm text-darkteal font-lato font-bold transform transition-transform duration-300 hover:scale-105">
                <Link to="/Demos">Demos</Link>
              </li>
              <li className="py-1 text-sm  text-darkteal font-lato font-bold transform transition-transform duration-300 hover:scale-105">
                <Link to="/FMFD">FM/FD</Link>
              </li>
              <li className="py-1 text-sm text-darkteal font-lato font-bold transform transition-transform duration-300 hover:scale-105">
                <Link to="/plannings">Monthly Review & Planning Report</Link>
              </li>
            </ul>
          )}

          <li
            className={`p-2 font-bold flex items-center ${
              location.pathname === "/managers" ||
              location.pathname === "/managers/show"
                ? "bg-liquidblue text-white"
                : ""
            } gap-2 rounded-lg mx-2 my-2`}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <circle
                  cx="12"
                  cy="6"
                  r="4"
                  fill={location.pathname === "/managers" ? "white" : "#056886"}
                ></circle>
                <path
                  d="M20 17.5C20 19.9853 20 22 12 22C4 22 4 19.9853 4 17.5C4 15.0147 7.58172 13 12 13C16.4183 13 20 15.0147 20 17.5Z"
                  fill={location.pathname === "/managers" ? "white" : "#056886"}
                ></path>
              </g>
            </svg>
            <Link
              to="/FSOMonthly"
              className="font-lato transform transition-transform duration-300 hover:scale-105"
            >
              Managers
            </Link>
            <button onClick={toggleMDropdown} className="ml-5">
              {openMDropdown ? "▲" : "▼"}
            </button>
          </li>
          {openMDropdown && (
            <ul className="mx-10 text-xs ">
              <li className="py-1 text-sm text-darkteal font-lato font-bold transform transition-transform duration-300 hover:scale-105">
                <Link to="/FSOMonthly ">FSO Monthly Report</Link>
              </li>
              <li className="py-1 text-sm text-darkteal font-lato font-bold transform transition-transform duration-300 hover:scale-105">
                <Link to="/AreaVisits">Area Visit Report</Link>
              </li>
              <li className="py-1 text-sm text-darkteal font-lato font-bold transform transition-transform duration-300 hover:scale-105">
                <Link to="/FMFDCoaching">FM/FD Coaching</Link>
              </li>
              <li className="py-1 text-sm text-darkteal font-lato font-bold transform transition-transform duration-300 hover:scale-105">
                <Link to="/SalesCoaching">Sales Call Coaching</Link>
              </li>
            </ul>
          )}

          <li
            className={`p-2 font-bold flex items-center ${
              location.pathname === "/expenses" ||
              location.pathname === "/expenses"
                ? "bg-liquidblue text-white"
                : ""
            } gap-2 rounded-lg mx-2 my-2`}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  d="M14 14H17M14 10H17M9 9.5V8.5M9 9.5H11.0001M9 9.5C7.20116 9.49996 7.00185 9.93222 7.0001 10.8325C6.99834 11.7328 7.00009 12 9.00009 12C11.0001 12 11.0001 12.2055 11.0001 13.1667C11.0001 13.889 11.0001 14.5 9.00009 14.5M9.00009 14.5L9 15.5M9.00009 14.5H7.0001M6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V8.2C21 7.0799 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.07989 19 6.2 19Z"
                  stroke="#056886"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </g>
            </svg>
            <Link
              to="/expenses"
              className="font-lato transform transition-transform duration-300 hover:scale-105"
            >
              Expenses
            </Link>
          </li>

          <li
            className={`p-2 font-bold flex items-center ${
              location.pathname === "/reports" ||
              location.pathname === "/reports/show"
                ? "bg-liquidblue text-white"
                : ""
            } gap-2 rounded-lg mx-2 my-2`}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 22 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 5C18.5 5 17.7 6.4 18.1 7.5L14.5 11.1C14.2 11 13.8 11 13.5 11.1L10.9 8.5C11.3 7.4 10.5 6 9 6C7.6 6 6.7 7.4 7.1 8.5L2.5 13C1.4 12.7 0 13.5 0 15C0 16.1 0.9 17 2 17C3.4 17 4.3 15.6 3.9 14.5L8.4 9.9C8.7 10 9.1 10 9.4 9.9L12 12.5C11.7 13.5 12.5 15 14 15C15.5 15 16.3 13.6 15.9 12.5L19.5 8.9C20.6 9.2 22 8.4 22 7C22 5.9 21.1 5 20 5ZM14 6L14.9 3.9L17 3L14.9 2.1L14 0L13.1 2.1L11 3L13.1 3.9L14 6ZM2.5 8L3 6L5 5.5L3 5L2.5 3L2 5L0 5.5L2 6L2.5 8Z"
                fill={
                  location.pathname === "/reports" ||
                  location.pathname === "/reports/show"
                    ? "white"
                    : "#056886"
                }
              />
            </svg>

            <Link
              to="/reports"
              className="font-lato transform transition-transform duration-300 hover:scale-105"
            >
              Review Reports
            </Link>
          </li>

          <li
            className={`p-2  font-bold flex items-center ${
              location.pathname === "/notifications"
                ? "bg-liquidblue text-white"
                : ""
            } gap-2 rounded-lg mx-2 my-2`}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 3.5C20 5.43 18.43 7 16.5 7C14.57 7 13 5.43 13 3.5C13 1.57 14.57 0 16.5 0C18.43 0 20 1.57 20 3.5ZM16.5 9C16.33 9 16.17 9 16 9V18H2V4H11.03C11 3.84 11 3.67 11 3.5C11 3 11.08 2.5 11.21 2H2C0.89 2 0 2.89 0 4V18C0 19.11 0.9 20 2 20H16C17.11 20 18 19.11 18 18V8.79C17.5 8.92 17 9 16.5 9Z"
                fill={
                  location.pathname === "/notifications" ? "white" : "#056886"
                }
              />
            </svg>

            <Link
              to="/notifications"
              className="font-lato transform transition-transform duration-300 hover:scale-105"
            >
              Notification
            </Link>
          </li>

          {userRole === "ADMIN" && (
            <li
              className={`p-2 font-bold flex items-center ${
                location.pathname === "/accounts"
                  ? "bg-liquidblue text-white"
                  : ""
              } gap-2 rounded-lg mx-2 my-2`}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 23 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 12V14H6V12C6 12 6 8 12 8C18 8 18 12 18 12ZM15 3C15 2.40666 14.8241 1.82664 14.4944 1.33329C14.1648 0.839943 13.6962 0.455426 13.1481 0.228363C12.5999 0.00129986 11.9967 -0.0581102 11.4147 0.0576455C10.8328 0.173401 10.2982 0.459123 9.87868 0.878681C9.45912 1.29824 9.1734 1.83279 9.05764 2.41473C8.94189 2.99667 9.0013 3.59987 9.22836 4.14805C9.45542 4.69623 9.83994 5.16477 10.3333 5.49441C10.8266 5.82405 11.4067 6 12 6C12.7956 6 13.5587 5.68393 14.1213 5.12132C14.6839 4.55871 15 3.79565 15 3ZM18.2 8.06C18.7466 8.5643 19.1873 9.17244 19.4964 9.84891C19.8054 10.5254 19.9766 11.2566 20 12V14H23V12C23 12 23 8.55 18.2 8.06ZM17 1.1415e-06C16.6979 0.000181955 16.3976 0.0474144 16.11 0.140001C16.6951 0.97897 17.0087 1.97718 17.0087 3C17.0087 4.02282 16.6951 5.02103 16.11 5.86C16.3976 5.95259 16.6979 5.99982 17 6C17.7956 6 18.5587 5.68393 19.1213 5.12132C19.6839 4.55871 20 3.79565 20 3C20 2.20435 19.6839 1.44129 19.1213 0.878681C18.5587 0.316072 17.7956 1.1415e-06 17 1.1415e-06ZM6.34 3.92L7.5 5.33L2.75 10.08L0 7.08L1.16 5.92L2.75 7.5L6.34 3.92Z"
                  fill={location.pathname === "/accounts" ? "white" : "#056886"}
                />
              </svg>

              <Link
                to="/accounts"
                className="font-lato transform transition-transform duration-300 hover:scale-105"
              >
                Accounts
              </Link>
            </li>
          )}

          {userRole === "ADMIN" && (
            <li
              className={`p-2 font-bold flex items-center ${
                location.pathname === "/requests"
                  ? "bg-liquidblue text-white"
                  : ""
              } gap-2 rounded-lg mx-2 my-2`}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 22 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 4C12 5.06087 11.5786 6.07828 10.8284 6.82843C10.0783 7.57857 9.06087 8 8 8C6.93913 8 5.92172 7.57857 5.17157 6.82843C4.42143 6.07828 4 5.06087 4 4C4 2.93913 4.42143 1.92172 5.17157 1.17157C5.92172 0.421427 6.93913 0 8 0C9.06087 0 10.0783 0.421427 10.8284 1.17157C11.5786 1.92172 12 2.93913 12 4ZM16 14V16H0V14C0 11.79 3.58 10 8 10C12.42 10 16 11.79 16 14ZM19.5 10.5V12H18V10.5H19.5ZM17.5 5.5H16V5C16 4.20435 16.3161 3.44129 16.8787 2.87868C17.4413 2.31607 18.2044 2 19 2C19.7956 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5C22 5.97 21.5 6.88 20.71 7.41L20.41 7.6C19.84 8 19.5 8.61 19.5 9.3V9.5H18V9.3C18 8.11 18.6 7 19.59 6.35L19.88 6.16C20.27 5.9 20.5 5.47 20.5 5C20.5 4.60218 20.342 4.22064 20.0607 3.93934C19.7794 3.65804 19.3978 3.5 19 3.5C18.6022 3.5 18.2206 3.65804 17.9393 3.93934C17.658 4.22064 17.5 4.60218 17.5 5V5.5Z"
                  fill={location.pathname === "/requests" ? "white" : "#056886"}
                />
              </svg>

              <Link
                to="/requests"
                className="font-lato transform transition-transform duration-300 hover:scale-105"
              >
                Requests
              </Link>
            </li>
          )}
          <li
            className={`p-2 font-bold flex items-center ${
              location.pathname === "/vehicles"
                ? "bg-liquidblue text-white"
                : ""
            } gap-2 rounded-lg mx-2 my-2`}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 22 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.9777 6.77124L19.4487 5.89994C19.4249 5.86153 19.386 5.83355 19.3404 5.82212C19.2948 5.81068 19.2463 5.81672 19.2054 5.83891L18.0738 6.46187L16.3262 1.91173C16.2339 1.64023 16.0525 1.4034 15.8082 1.23544C15.5639 1.06748 15.2693 0.977081 14.9669 0.977295H5.2958C4.52131 0.977295 3.83386 1.44872 3.59504 2.14535L1.92999 6.46397L0.796154 5.84101C0.755275 5.81882 0.706746 5.81279 0.661164 5.82422C0.615582 5.83566 0.57665 5.86364 0.552869 5.90205L0.0238929 6.77124C-0.0252104 6.85122 0.00380525 6.95224 0.0886201 6.99854L1.43673 7.73936L1.11309 8.58119C1.08631 8.64854 1.07292 8.7201 1.07292 8.79165V16.1199C1.07292 16.4503 1.33629 16.7176 1.65993 16.7176H3.16874C3.44327 16.7176 3.68209 16.5218 3.74012 16.2482L3.91198 15.4548H16.0896L16.2615 16.2482C16.3217 16.5218 16.5583 16.7176 16.8328 16.7176H18.3417C18.6653 16.7176 18.9287 16.4503 18.9287 16.1199V8.79165C18.9287 8.7201 18.9153 8.64854 18.8885 8.58119L18.5649 7.73936L19.9107 6.99854C19.9512 6.97648 19.981 6.9403 19.9935 6.8978C20.006 6.85529 20.0003 6.80985 19.9777 6.77124ZM4.46551 11.1404C3.97224 11.1404 3.57272 10.7637 3.57272 10.2985C3.57272 9.83343 3.97224 9.45671 4.46551 9.45671C4.95878 9.45671 5.3583 9.83343 5.3583 10.2985C5.3583 10.7637 4.95878 11.1404 4.46551 11.1404ZM13.1255 12.7188C13.1255 12.8114 13.0452 12.8872 12.947 12.8872H7.05459C6.95639 12.8872 6.87604 12.8114 6.87604 12.7188V10.951C6.87604 10.8584 6.95639 10.7826 7.05459 10.7826H7.94738C8.04559 10.7826 8.12594 10.8584 8.12594 10.951V11.7086H11.8756V10.951C11.8756 10.8584 11.956 10.7826 12.0542 10.7826H12.947C13.0452 10.7826 13.1255 10.8584 13.1255 10.951V12.7188ZM15.5361 11.1404C15.0428 11.1404 14.6433 10.7637 14.6433 10.2985C14.6433 9.83343 15.0428 9.45671 15.5361 9.45671C16.0293 9.45671 16.4289 9.83343 16.4289 10.2985C16.4289 10.7637 16.0293 11.1404 15.5361 11.1404ZM3.48344 6.86805L5.10608 2.66097L5.11724 2.63361L5.12617 2.60625C5.15072 2.5368 5.21768 2.4905 5.2958 2.4905H14.8397L16.5226 6.86805H3.48344Z"
                fill={location.pathname === "/vehicles" ? "white" : "#056886"}
              />
            </svg>

            <Link
              to="/vehicles"
              className="font-lato transform transition-transform duration-300 hover:scale-105"
            >
              Vehicles
            </Link>
          </li>
          <li
            className={`p-2 font-bold flex items-center ${
              location.pathname === "/logout" ? "bg-liquidblue text-white" : ""
            } gap-2 rounded-lg mx-2 my-2`}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 16 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.00455 3.4C10.1045 3.4 12.1045 4.2 13.6045 5.7C16.7045 8.8 16.7045 13.9 13.6045 17C11.8045 18.9 9.30454 19.6 6.90454 19.3L7.40454 17.3C9.10454 17.5 10.9045 16.9 12.2045 15.6C14.5045 13.3 14.5045 9.5 12.2045 7.1C11.1045 6 9.50455 5.4 8.00455 5.4V10L3.00455 5L8.00455 0V3.4ZM2.30455 17C-0.295454 14.4 -0.695455 10.4 1.10455 7.3L2.60455 8.8C1.50455 11 1.90455 13.8 3.80455 15.6C4.30455 16.1 4.90455 16.5 5.60455 16.8L5.00455 18.8C4.00455 18.4 3.10455 17.8 2.30455 17Z"
                fill="#056886"
              />
            </svg>
            <button
              onClick={handleOpen}
              className="font-lato transform transition-transform duration-300 hover:scale-105"
            >
              Logout
            </button>
          </li>
        </ul>
      </nav>

      <div
        className={`fixed inset-0 flex items-center justify-center ${
          showModal ? "block" : "hidden"
        }  p-4 `}
        onClick={handleClose}
      >
        <div
          className="bg-white p-6 rounded shadow-md"
          onClick={(e) => e.stopPropagation()}
        >
          <h2 className="text-xl mb-4 p-4">Do you want to logout?</h2>
          <div className="flex justify-around p-4">
            <button
              className="bg-red-600 text-white px-4 py-2 rounded"
              onClick={handleClose}
            >
              No
            </button>
            <button
              className="bg-darkteal text-white px-4 py-2 rounded"
              onClick={logout}
            >
              Yes
            </button>
          </div>
        </div>
      </div>

      <Link to="" className="font-lato ">
        <div className="flex justify-center mt-4">
          <svg
            width="30"
            height="30"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M30 51.6C22.5 51.6 15.87 47.76 12 42C12.09 36 24 32.7 30 32.7C36 32.7 47.91 36 48 42C44.13 47.76 37.5 51.6 30 51.6ZM30 9C32.3869 9 34.6761 9.94821 36.364 11.636C38.0518 13.3239 39 15.6131 39 18C39 20.3869 38.0518 22.6761 36.364 24.364C34.6761 26.0518 32.3869 27 30 27C27.6131 27 25.3239 26.0518 23.636 24.364C21.9482 22.6761 21 20.3869 21 18C21 15.6131 21.9482 13.3239 23.636 11.636C25.3239 9.94821 27.6131 9 30 9ZM30 0C26.0603 0 22.1593 0.775973 18.5195 2.28361C14.8797 3.79126 11.5726 6.00104 8.7868 8.7868C3.16071 14.4129 0 22.0435 0 30C0 37.9565 3.16071 45.5871 8.7868 51.2132C11.5726 53.999 14.8797 56.2087 18.5195 57.7164C22.1593 59.224 26.0603 60 30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 13.41 46.5 0 30 0Z"
              fill="#056886"
            />
          </svg>
        </div>
      </Link>

      <p className="text-liquidblue text-center font-bold text-sm">
        {userRole}
      </p>
    </div>
  );
};

export default Sidebar;
